import { useIntl } from 'react-intl';
import Input from 'src/componentes/input';

const SearchBar = ({ searchQuery, setSearchQuery }) => {
  const intl = useIntl();

  return (
    <div style={{ marginBottom: '24px' }}>
      <div style={{ position: 'relative' }}>
        <Input
          placeholder={intl.formatMessage({ id: 'labelPesquisarFiltros' })}
          model={{
            value: searchQuery,
            requestChange: (value) => setSearchQuery(String(value || '')),
          }}
          style={{
            paddingRight: '40px',
            fontSize: '14px',
          }}
        />
      </div>
    </div>
  );
};

export default SearchBar;